import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useChatContext } from '../context/ChatContext.jsx'

export function useChatActions() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { messages, navAlwaysAllow, navAutoNavigatedIds, markNavAutoNavigated } = useChatContext()

  useEffect(() => {
    const lastMsg = messages[messages.length - 1]
    if (lastMsg?.role !== 'assistant' || !lastMsg?.returned_path || !navAlwaysAllow) return

    const path = lastMsg.returned_slug
      ? `${lastMsg.returned_path}/${lastMsg.returned_slug}`
      : lastMsg.returned_path

    if (pathname === path) return
    if (navAutoNavigatedIds.includes(lastMsg.id)) return

    markNavAutoNavigated(lastMsg.id)
    navigate(path)
  }, [messages, navigate, navAlwaysAllow, navAutoNavigatedIds, markNavAutoNavigated, pathname])
}
